export const TICKET_MANAGEMENT_BASE_PATH = '/ticket-management';
export const ANALYTICS_BASE_PATH = '/analytics';
export const QUERYBUILDER = '/queryBuilder';
export const REPORTS = '/reports';
export const LIA_CO_PILOT_BASE_PATH = '/co-pilot';
